import { motion } from "framer-motion";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const faqs = [
  {
    q: "Brauche ich Vorkenntnisse?",
    a: "Nein. Der Kurs ist für absolute Einsteiger gebaut. Die KI-Tools übernehmen den technischen Part — du lernst den Prozess und den Verkauf.",
  },
  {
    q: "Wie viel Zeit brauche ich pro Woche?",
    a: "5–10 Stunden reichen, um deinen ersten Kunden zu gewinnen. Eine Website entsteht in ca. 2 Stunden. Den Rest macht die Methode.",
  },
  {
    q: "Muss ich Geld für Tools ausgeben?",
    a: "Für den Kurs selbst brauchst du nichts weiter. Um die Methode danach umzusetzen, fallen ca. 20€ pro Monat für die KI-Tools an — die sich schon mit dem ersten Kunden (1.000–3.000€ pro Website) um ein Vielfaches auszahlen.",
  },
  {
    q: "Wie schnell kann ich starten?",
    a: "Sofort nach dem Kauf hast du Zugang. Mit der Methode ist dein erster zahlender Kunde in unter 24 Stunden möglich.",
  },
];

function FAQRow({ item, isOpen, onClick, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease, delay: index * 0.07 }}
      className="border-b border-white/6 last:border-0"
      data-testid={`faq-item-${index}`}
    >
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between py-6 text-left group"
        data-testid={`faq-trigger-${index}`}
      >
        <span className="text-[#F5F5F7] font-semibold text-base sm:text-lg pr-6 group-hover:text-[#C9A84C] transition-colors duration-200">
          {item.q}
        </span>
        <div className="shrink-0 w-6 h-6 flex items-center justify-center">
          {isOpen ? (
            <Minus className="w-4 h-4 text-[#C9A84C]" />
          ) : (
            <Plus className="w-4 h-4 text-[#86868b] group-hover:text-[#C9A84C] transition-colors" />
          )}
        </div>
      </button>
      <motion.div
        initial={false}
        animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
        transition={{ duration: 0.35, ease: "easeInOut" }}
        className="overflow-hidden"
      >
        <p className="pb-6 text-[#86868b] text-base leading-relaxed">{item.a}</p>
      </motion.div>
    </motion.div>
  );
}

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="faq-section"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-14"
        >
          <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
            FAQ
          </span>
          <h2
            className="text-4xl sm:text-5xl font-black text-[#F5F5F7] mt-4 tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Häufige Fragen.
          </h2>
        </motion.div>

        <div>
          {faqs.map((item, i) => (
            <FAQRow
              key={i}
              item={item}
              index={i}
              isOpen={openIdx === i}
              onClick={() => toggle(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
